import { useForm as useHookForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

export type FormValue = {
  currency_unit: string;
};

type Props = {
  symbolsTaxExChange?: Response.SymbolItem[];
};

const useForm = ({ symbolsTaxExChange }: Props) => {
  const symbolOptions = [
    symbolsTaxExChange?.map((item) => {
      return {
        label: item.symbol,
        value: item.moneyType,
      };
    }),
  ];

  const schema = Yup.object().shape({});

  const form = useHookForm<FormValue>({
    resolver: yupResolver(schema),
    shouldFocusError: true,
  });
  return { ...form, symbolOptions };
};

export default useForm;
